"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DefaultSvg", {
    enumerable: true,
    get: ()=>DefaultSvg
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const DefaultSvg = ()=>/*#__PURE__*/ _react.createElement("svg", {
        className: "fui-Spinner__Progressbar"
    }, /*#__PURE__*/ _react.createElement("circle", {
        className: "fui-Spinner__Track"
    }), /*#__PURE__*/ _react.createElement("circle", {
        className: "fui-Spinner__Tail"
    })); //# sourceMappingURL=DefaultSvg.js.map

//# sourceMappingURL=DefaultSvg.js.map